import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { FaEdit } from 'react-icons/fa'
import {
  Badge,
  Btn,
  BtnIcon,
  CustomDataTableHeader,
  CustomModal,
  CustomPanel,
  InputNumeroDecimal,
  InputNumeroInteiro,
  Loading,
  OcorrenciasDropdown,
  PageHeader,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { ocorrenciasPorEntrega } from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { tableCellCentered } from '../../../../assets/js/styles'
import { laranja, vinho } from '../../../../assets/js/colors'
import ModalAjusteFalta from '../../Entrega/Ocorrencias/Falta/ModalAjusteFalta'
import * as RetornoHttp from '../../../../services/api/https/deliveries/retorno.http'
import {
  buildFaltaQuantityInputState,
  getFaltaQuantityConfig,
  getFaltaQuantityValueFromInputs,
} from '../../Entrega/Ocorrencias/Falta/falta-volume-and-units.helper'
import {
  getOrdemColetaInputLabels,
  renderOrdemColetaQuantityCell,
} from '../ordem-coleta-volume-and-units.helper'

function OcorrenciasPorEntrega({ history, dispatch }) {
  // Vars
  const { delivery_id, identifier, razao_social, delivery_step_id } = history.location.state
  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [ocorrencias, setOcorrencias] = useState([])
  const [showModalAjusteFalta, setShowModalAjusteFalta] = useState(false)
  const [showModalNovaFalta, setShowModalNovaFalta] = useState(false)
  const [selectedOcorrencia, setSelectedOcorrencia] = useState(null)
  useEffect(() => {
    getOcorrencias()
  }, [delivery_id])

  // Events
  const onBtnNovaOcorrenciaClick = () => {
    setShowModalNovaFalta(true)
  }

  const onBtnEditClicked = ocorrencia => {
    setSelectedOcorrencia(ocorrencia)
    setShowModalAjusteFalta(true)
  }

  const onModalAjusteFaltaClose = () => {
    setShowModalAjusteFalta(false)
  }

  const onModalAjusteFaltaError = error => {
    dispatch(showMessageBox(null, error))
    setShowModalAjusteFalta(false)
  }

  const onModalAjusteFaltaSuccess = ocorrencia => {
    const index = ocorrencias.findIndex(o => o.missing_product_id === ocorrencia.missing_product_id)
    if (index !== -1) {
      const newOcorrencias = [...ocorrencias]
      newOcorrencias[index] = ocorrencia
      setOcorrencias(newOcorrencias)
    }
    setShowModalAjusteFalta(false)
  }

  const onModalNovaFaltaError = error => {
    dispatch(showMessageBox(null, error))
    setShowModalNovaFalta(false)
  }

  const onModalNovaFaltaClose = () => {
    setShowModalNovaFalta(false)
  }

  const onModalNovaFaltaSalvar = fetchedOcorrencias => {
    setOcorrencias(fetchedOcorrencias)
    setShowModalNovaFalta(false)
  }
  // Helpers
  const getOcorrencias = async () => {
    try {
      const fetchedOcorrencias = await ocorrenciasPorEntrega(delivery_id)
      setOcorrencias(fetchedOcorrencias)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return (
    <React.Fragment>
      <PageHeader>
        Ocorrências da Entrega &nbsp;
        <strong>{`${identifier} - ${razao_social}`}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onVoltar={history.goBack}
          showBtnNovo={true}
          onNovo={onBtnNovaOcorrenciaClick}
          btnLabel="Nova Ocorrência"
        >
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            <DataTable value={ocorrencias}>
              <Column field="product_code" header="Código" style={tableCellCentered(80)} />
              <Column field="product_name" header="Produto" />
              <Column field="reason" header="Motivo" style={tableCellCentered(200)} />
              <Column
                field="qte_missing"
                header="Qte. Faltas"
                style={tableCellCentered(110)}
                body={ocorrencia => renderOrdemColetaQuantityCell(ocorrencia, ocorrencia.qte_missing)}
              />
              <Column
                field="qte_adjusted"
                header="Qte. Correção"
                style={tableCellCentered(110)}
                body={ocorrencia =>
                  renderOrdemColetaQuantityCell(ocorrencia, ocorrencia.qte_adjusted || 0)
                }
              />
              <Column
                field="adjust_justification"
                header="Justificativa"
                style={tableCellCentered(200)}
              />
              <Column
                field="state"
                header="Etapa"
                style={tableCellCentered()}
                body={ocorrencia => {
                  return ocorrencia.stage === 'Separacao' ? (
                    <Badge color={laranja}>{ocorrencia.stage}</Badge>
                  ) : (
                    <Badge color={vinho}>{ocorrencia.stage}</Badge>
                  )
                }}
              />
              <Column
                header=""
                body={ocorrencia => (
                  <BtnIcon onClick={() => onBtnEditClicked(ocorrencia)}>
                    <FaEdit color="red" size={18} />
                  </BtnIcon>
                )}
                style={{ textAlign: 'center', width: 80 }}
              />
            </DataTable>
          )}
          {showModalAjusteFalta ? (
            <ModalAjusteFalta
              falta={selectedOcorrencia}
              onModalClose={onModalAjusteFaltaClose}
              onError={onModalAjusteFaltaError}
              ignorarStatusEntrega={true}
              onSuccess={onModalAjusteFaltaSuccess}
            />
          ) : null}
          {showModalNovaFalta ? (
            <ModalNovaFalta
              deliveryId={delivery_id}
              onModalNovaFaltaClose={onModalNovaFaltaClose}
              onModalNovaFaltaError={onModalNovaFaltaError}
              onModalNovaFaltaSalvar={onModalNovaFaltaSalvar}
              deliveryStepId={delivery_step_id}
            />
          ) : null}
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

function ModalNovaFalta({
  deliveryId,
  deliveryStepId,
  onModalNovaFaltaClose,
  onModalNovaFaltaError,
  onModalNovaFaltaSalvar,
}) {
  // Hooks
  useEffect(() => {
    fetchDeliveryItems()
  }, [deliveryId])
  const [globalFilter, setGlobalFilter] = useState('')
  const [items, setItems] = useState([])
  const [reasons, setReasons] = useState([])

  // Events
  const onFormContentChange = (item, name, value) => {
    const index = items.findIndex(i => i.delivery_item_id === item.delivery_item_id)
    if (index !== -1) {
      switch (name) {
        case 'selected_reason':
          items[index].reason_value = value
          break
        case 'qte_missing_volume':
        case 'qte_missing_units': {
          items[index][name] = value
          const qteMissing = getFaltaQuantityValueFromInputs(
            items[index],
            items[index].qte_missing_volume,
            items[index].qte_missing_units,
          )
          items[index].qte_missing = qteMissing
          if (qteMissing === '' || Number(qteMissing) === 0) {
            items[index].qte_missing = ''
            items[index].reason_value = ''
          }
          break
        }
        default:
          break
      }
      setItems([...items])
    }
  }

  const renderQuantityInput = (item, field) => {
    const { canUseFractionedInput } = getFaltaQuantityConfig(item)
    const { volumeLabel, unitsLabel } = getOrdemColetaInputLabels(item)
    const isVolumeField = field === 'qte_missing_volume'
    const label = isVolumeField ? volumeLabel : unitsLabel
    const isCustomLabel = label !== (isVolumeField ? 'Vol' : 'Uni')

    return (
      <div style={{ minWidth: 80 }}>
        {isCustomLabel ? (
          <div
            style={{
              fontSize: '0.72rem',
              color: '#666',
              fontWeight: 600,
              textAlign: 'center',
              marginBottom: 4,
            }}
          >
            {label}
          </div>
        ) : null}
        {isVolumeField ? (
          canUseFractionedInput ? (
            <InputNumeroInteiro
              marginTop={0}
              value={item.qte_missing_volume}
              onChange={value => onFormContentChange(item, field, value)}
              width={80}
            />
          ) : (
            <InputNumeroDecimal
              marginTop={0}
              showLabel={false}
              value={item.qte_missing_volume}
              onChange={value => onFormContentChange(item, field, value)}
              width={80}
            />
          )
        ) : (
          <InputNumeroInteiro
            marginTop={0}
            value={item.qte_missing_units}
            onChange={value => onFormContentChange(item, field, value)}
            width={80}
            disabled={!canUseFractionedInput}
          />
        )}
      </div>
    )
  }

  const onBtnSalvarClicked = async () => {
    try {
      items.forEach(i => {
        if (i.qte_missing && Number(i.qte_missing) > i.product_qte)
          throw new Error('A quantidade de Falta não pode ser MAIOR que a quantidade Total')
        if (Number(i.qte_missing) <= 0) throw new Error('Quantidade Incorreta. Favor verifique')
      })

      const selectedItems = items.filter(i => i.reason_value && Number(i.qte_missing) > 0)
      if (selectedItems.length === 0) throw new Error('Não existe(m) ocorrências preenchidas')

      const info = selectedItems.map(i => ({
        delivery_item_id: i.delivery_item_id,
        missing_reason_id: i.reason_value,
        stage: 'Entrega',
        qte_missing: Number(i.qte_missing),
      }))

      const fetched_missing_products = await RetornoHttp.postMissingProductStageEntrega(
        deliveryStepId,
        info,
      )
      onModalNovaFaltaSalvar(fetched_missing_products)
    } catch (error) {
      onModalNovaFaltaError(errorHandler(error))
    }
  }

  // Helpers
  const fetchDeliveryItems = async () => {
    try {
      const { products, missing_reasons } =
        await RetornoHttp.getInfoMissingProductStageEntrega(deliveryId)
      setItems(products.map(product => ({ ...product, ...buildFaltaQuantityInputState(product, '') })))
      setReasons(missing_reasons)
    } catch (error) {
      onModalNovaFaltaError(errorHandler(error))
    }
  }

  // Render
  return (
    <CustomModal header="Nova Ocorrência" isVisible={true} onClose={onModalNovaFaltaClose}>
      <div>
        <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
      </div>
      <div style={{ marginTop: 20 }}>
        <DataTable
          value={items}
          paginator={true}
          rows={5}
          header={<CustomDataTableHeader onChange={setGlobalFilter} />}
          globalFilter={globalFilter}
        >
          <Column field="product_code" style={tableCellCentered(80)} header="Código" />
          <Column field="product_name" header="Produto" />
          <Column
            field="product_qte"
            header="Quant."
            style={tableCellCentered(110)}
            body={item => renderOrdemColetaQuantityCell(item, item.product_qte)}
          />
          <Column
            header="Ocorrência"
            body={item => (
              <OcorrenciasDropdown
                style={{ width: '100%' }}
                value={item.reason_value ? item.reason_value : ''}
                options={reasons}
                onChange={({ value }) => onFormContentChange(item, 'selected_reason', value)}
              />
            )}
          />
          <Column
            header="Qte Faltas (Vol)"
            style={tableCellCentered(110)}
            body={item => renderQuantityInput(item, 'qte_missing_volume')}
          />
          <Column
            header="Qte Faltas (Uni)"
            style={tableCellCentered(100)}
            body={item => renderQuantityInput(item, 'qte_missing_units')}
          />
        </DataTable>
      </div>
    </CustomModal>
  )
}

export default connect()(withRouter(OcorrenciasPorEntrega))
